import {BaseElement, OSkinableInit} from "/@back@/commons/basis.js";
import {IItemUiEnv, installSrcViewFileDrop} from "/@back@/wsp/views/itemMain.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {IView} from "/@lib@/commons/views.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {ActionBtn, OActionBtnInit} from "/@back@/commons/widgets/buttons.js";
import {ExportRes, ImportRes} from "/@back@/wsp/actions/itemActions.js";

/**
 * View du contenu d'un item binaire sans visulaisation dispo : seul un download est possible.
 */
export interface OItemDownloadInit extends OSkinableInit {
	reg?: IReg<IItemUiEnv>
}

export interface ItemDownload extends BaseElement {
	initialize(init: OItemDownloadInit): this;
}

export class ItemDownload extends BaseElement implements IView {
	reg: IReg<IItemUiEnv>;

	_initialize(init: OItemDownloadInit) {
		this.reg = this.findReg(init);
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		installSrcViewFileDrop(this.reg, this);
		sr.appendChild(<div class="msg">Ce contenu ne peut être visualisé</div>);
		sr.appendChild(<ActionBtn î={{action: new ExportRes(), actionContext: this.reg.env.srcView, uiContext:"dialog"} satisfies OActionBtnInit<any>}/>);
		sr.appendChild(<ActionBtn î={{action: new ImportRes(), actionContext: this.reg.env.srcView, uiContext:"dialog"} satisfies OActionBtnInit<any>}/>);
	}
}

REG.reg.registerSkin("wsp-item-download", 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex: 1;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.msg {
			color: var(--info-color);
  }
	
`);


customElements.define("wsp-item-download", ItemDownload);
